import axois from "axios";
import API from "./api";
import { BaseApiService } from "./api-base";
import sender from "./sender";
import { IAddLomChannel, IAddLomEntity } from "src/modules/loms/models";
import { IMediaplanItem } from "src/modules/mediaplans/models/mediaplans";
interface IBotQueryParams {
  search?: string;
  platform_guid?: string | null;
  role_guid?: string | null;
  blocked?: boolean | null;
  limit?: number | undefined;
  offset?: number | undefined;
}

interface ILomTaskQueryParams {
  approve?: boolean[];
  scale?: number;
  channel_guid?: string[];
  lom_guid?: string[];
  limit?: number;
  offset?: number;
}

interface IChannelQueryParams {
  search?: string;
  platform_guid?: string | null;
  autosend?: string | null;
  limit?: number | undefined;
  offset?: number | undefined;
}

interface IEntityQueryParams {
  search?: string;
  limit?: number | undefined;
  offset?: number | undefined;
}
export class SqlrApiService extends BaseApiService {
  constructor(host: string) {
    super("sqlr");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  get(method: string, params: any = undefined, headers: any = {}) {
    const path = `${this.url}/${method}`;
    headers["Authorization"] = headers["Authorization"] || this.jwt;
    return sender.restGet(path, params, headers);
  }

  post(method: string, body: any = undefined, headers: any = {}) {
    const path = `${this.url}/rpc/${method}`;
    headers["Authorization"] = headers["Authorization"] || this.jwt;
    return sender.restPost(path, body, headers);
  }

  // ===========================================================
  // audio
  // ===========================================================
  get_audio_by_guid_db(guid: string) {
    const method = "get_audio_by_guid";
    const body = { guid };
    return this.post(method, body);
  }
  // ===========================================================
  // messages
  // ===========================================================

  set_edit(data: { id: any; guid: any; new_text: any }) {
    let method = "";
    if (data.guid) {
      method = "ds_set_edit";
      data.id = undefined;
    } else if (data.id) {
      method = "dataset_examples_set_edit";
    }
    const body = {
      ...data,
      login: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  get_questions(data: {
    internal_id: any;
    limit: number;
    offset: number;
    text: string;
  }) {
    const method = "t_answers";
    const params = {
      internal_id: _eq(data.internal_id),
      limit: data.limit,
      offset: data.offset,
      or:
        data.text !== undefined
          ? "(question_template.like.*" +
            data.text +
            "*,answer.like.*" +
            data.text +
            "*)"
          : data.text,
    };
    return this.get(method, params).then((classes) => {
      const texts = [];
      for (let i = 0; i < classes.length; i++) {
        const item = classes[i];
        texts.push(item.question_template ? item.question_template : "");
        texts.push(item.answer ? item.answer : "");
      }
      return API.ds.transform_text(texts).then((data) => {
        const result = [];
        const texts = data.texts;
        for (let i = 0, j = 0; i < texts.length; i += 2, j++) {
          result.push({
            question_template: texts[i],
            answer: texts[i + 1],
            internal_id: classes[j].internal_id,
          });
        }
        return result;
      });
    });
  }
  // ===========================================================
  // dataset
  // ===========================================================
  /**
   *
   * @param {*} order_by at | count_all | count_not_check
   * @param {*} order_type asc | desc
   */
  get_dataset_stat_count(data: {
    logins: any;
    date_start: any;
    date_end: any;
    only_not_check: any;
    internal_id: number[];
    skip: any;
    take: any;
    order_by: "at" | "count_all" | "count_not_check";
    order_type: "asc" | "desc";
  }) {
    if (!data.order_by) data.order_by = "at";
    if (!data.order_type) data.order_type = "asc";
    const method = "get_dataset_examples_count_with_date";
    const body = {
      logins: data.logins?.length ? data.logins : undefined,
      date_start: data.date_start,
      date_end: data.date_end ? `${data.date_end} 23:59:59` : undefined,
      only_not_check: data.only_not_check,
      internal_id: data.internal_id?.length ? data.internal_id : undefined,
      order_by: data.order_by,
      order_type: data.order_type,
      skip: data.skip,
      take: data.take,
    };
    return this.post(method, body);
  }

  get_dataset_control_count(data: { login: any; logins: any; mark: any }) {
    const method = "dataset_control_count";
    const params = {
      controller: _eq(data.login),
      or: _or("controller", data.logins, "eq"),
      mark: _eq(data.mark),
    };
    return this.get(method, params);
  }
  dataset_examples_refresh_duplicate() {
    const method = "dataset_examples_refresh_duplicate";
    const body = {};
    return this.post(method, body);
  }
  set_dataset_control_v2(data: { guid: any; rate: any }) {
    const method = "ds_set_dataset_control";
    const body = { ...data, controller: this.store.state.user.id };
    return this.post(method, body);
  }
  set_dataset_control(data: {
    id: any;
    guid: any;
    rate: any;
    controller: any;
    reason: number;
  }) {
    let method = "";
    if (data.guid) {
      method = "ds_set_dataset_control";
      data.id = undefined;
    } else if (data.id) {
      method = "dataset_examples_set_control";
      data.guid = undefined;
    }
    const body = data;
    return this.post(method, body);
  }
  dataset_audio_examples_set_emoj(data: { id: any; emoj: any }) {
    const method = "dataset_audio_examples_set_emoj";
    const body = data;
    return this.post(method, body);
  }
  get_dataset_examples(data: {
    logins: any;
    limit: any;
    offset: any;
    order: any;
    date_start: any;
    date_end: any;
    internal_id: number[] | string[];
    control_rate: any;
    mark: any;
    src_type: any;
  }) {
    if (data.mark == "dataset" || data.control_rate != "eq.0") {
      const method = "dataset_examples";
      // console.log("logins", data.logins);
      const logins_f = data.logins?.length
        ? `or${_or("user_login", data.logins, "eq")}`
        : "";
      const date_start_f = data.date_start
        ? `at.gte.${data.date_start}`
        : undefined;
      const date_end_f = data.date_end
        ? `at.lte.${data.date_end} 23:59:59`
        : undefined;
      const and_f = [logins_f, date_start_f, date_end_f]
        .filter((x) => x)
        .join(",");
      const and = and_f ? `(${and_f})` : undefined;
      const internal_ids = data.internal_id?.length
        ? `in.(${data.internal_id.join(",")})`
        : undefined;
      const params = {
        limit: data.limit,
        offset: data.offset,
        order: data.order || "at.desc",
        user_rate: _neq(-1),
        control_rate: data.control_rate,
        and,
        mark: _eq(data.mark),
        src_type: _eq(data.src_type),
        internal_id: internal_ids,
      };
      return this.get(method, params);
    } else if (data.mark == "dataset_audio") {
      const path = "get_dataset_audio_examples";
      const body = {
        user_login: this.store.state.user.id,
        src_type: data.src_type,
      };
      return this.post(path, body);
    }
  }
  get_dataset_examples_messages(data: {
    logins: any;
    limit: number;
    offset: number;
  }) {
    const method = "dataset_examples_messages";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order: "at.desc",
      or: _or("user_login", data.logins, "eq"),
    };
    return this.get(method, params);
  }
  audio_examples_src_types() {
    const method = "audio_examples_src_types";
    return this.get(method);
  }
  // ===========================================================
  // operator
  // ===========================================================
  get_dialogs(data: {
    owner: any;
    dialog_id: any;
    chanel: any;
    limit: any;
    offset: any;
    date_start: any;
    date_end: any;
    is_redirect: any;
  }) {
    const method = "ds_dialogs_fast";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order: "last_at.desc",
      dialog_id: _eq(data.dialog_id),
      chanel: _eq(data.chanel),
      owner: data.owner,
      last_message_id: "not.is.null",
      is_redirect: _eq(data.is_redirect),
    };
    if (data.date_start && data.date_end) {
      (params as any).and =
        "(dialog_at_date." +
        _filter(data.date_start, "gte") +
        ",dialog_at_date." +
        _filter(data.date_end, "lte") +
        ")";
    } else if (data.date_start) {
      (params as any).dialog_at_date = _filter(data.date_start, "gte");
    } else if (data.date_end) {
      (params as any).dialog_at_date = _filter(data.date_end, "lte");
    }
    return this.get(method, params);
  }
  get_messages(data: { dialog_id: any; limit: number; offset: number }) {
    const method = "ds_messages";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order: "at.desc",
      dialog_id: "eq." + data.dialog_id,
    };
    return this.get(method, params);
  }
  get_op(data: { limit: number; offset: number }) {
    const method = "ds_clients";
    const params = {
      ...data,
      order: "at.desc",
      type: "eq.operator",
    };
    return this.get(method, params);
  }
  // ===========================================================
  // polls
  // ===========================================================
  get_polls(data: { limit: number; offset: number; filter_name: any }) {
    const method = "ds_polls";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order: "at.desc",
      name: _ilike(data.filter_name),
    };
    return this.get(method, params);
  }
  save_polls(data: { id: any; name: any; text: any; state: any }) {
    const body = data;
    if (data.id !== undefined) {
      const method = "ds_update_polls";
      return this.post(method, body);
    } else {
      // Вырожденный случай
      const method = "ds_polls";
      const headers = {
        Authorization: this.jwt,
        Prefer: "return=representation",
      };
      const path = `${this.url}/${method}`;
      return sender.restPost(path, body, headers);
    }
  }
  del_polls(data: { id: any }) {
    const method = "ds_delete_polls";
    const body = data;
    return this.post(method, body);
  }
  // ===========================================================
  // dataset synt
  // ===========================================================
  dataset_lines(data: {
    is_empty: any;
    line_id: any;
    mark: any;
    rank: any;
    limit: any;
    offset: any;
  }) {
    const method = "get_dataset_lines";
    const body = {
      is_empty: data.is_empty,
      line_id: data.line_id,
      mark: data.mark,
      rank: data.rank,
      lim: data.limit,
      offs: data.offset,
      logins: this.store.state.user.logins,
    };
    return this.post(method, body);
  }
  dataset_lines_count(data: {
    is_empty: any;
    line_id: any;
    mark: any;
    rank: any;
  }) {
    const method = "get_dataset_lines_count";
    const body = {
      ...data,
      logins: this.store.state.user.logins,
    };
    return this.post(method, body);
  }
  dataset_lines_marks() {
    const method = "dataset_lines_marks";
    const params = {};
    return this.get(method, params);
  }
  dataset_line_update(data: { line_id: any; text: any }) {
    const method = "dataset_lines_update";
    const body = { id: data.line_id, text: data.text };
    return this.post(method, body);
  }
  ds_select_message(data: { guid: any }) {
    const method = "ds_select_message";
    const body = data;
    return this.post(method, body);
  }
  get_dataset_synt_time_stat(data: { logins: any }) {
    const method = "get_dataset_synt_time_stat";
    const body = data;
    return this.post(method, body);
  }
  // ===========================================================
  // sip
  // ===========================================================
  get_sip_messages(data: { limit: number; offset: number }) {
    const method = "dialog_sip_logs";
    const params = { ...data, order: "log_time.desc" };
    return this.get(method, params);
  }
  // ===========================================================
  // bl_1
  // ===========================================================
  get_bl_1_entities(data: {
    parent_id: any;
    limit: any;
    offset: any;
    filter_name: any;
  }) {
    const method = "bl_1_entities";
    const params = {
      limit: data.limit,
      offset: data.offset,
      parent_id: _eq(data.parent_id),
      order: "name",
      name: _ilike(data.filter_name),
    };
    return this.get(method, params);
  }
  add_bl_1_entity(data: { parent_id: any; name: any }) {
    const method = "bl_1_add_ent_syn";
    const body = data;
    return this.post(method, body);
  }
  update_bl_1_entities(data: { id: any; name: any }) {
    const method = "bl_1_update_entities";
    const body = { id: parseInt(data.id), name: data.name };
    return this.post(method, body);
  }
  delete_bl_1_entity(data: { ent_id: any }) {
    const method = "bl_1_delete_ent";
    const body = data;
    return this.post(method, body);
  }
  get_bl_1_synonyms(data: { ent_id: any; limit: any; offset: any }) {
    const method = "bl_1_synonyms";
    const params = {
      limit: data.limit,
      offset: data.offset,
      ent_id: _eq(data.ent_id),
      order: "id",
    };
    return this.get(method, params);
  }
  add_bl_1_synonyms(data: { parent_id: any; synonym: any }) {
    const method = "bl_1_add_syn";
    const body = { parent_id: data.parent_id, ent_syn: data.synonym };
    return this.post(method, body);
  }
  update_bl_1_synonyms(data: { id: any; synonym: any }) {
    const method = "bl_1_update_synonyms";
    const body = data;
    return this.post(method, body);
  }
  delete_bl_1_synonyms(data: { id: any }) {
    const method = "bl_1_delete_syn";
    const body = { ent_syn_id: data.id };
    return this.post(method, body);
  }
  get_bl_1_descriptions(data: { ent_id: any; limit: any; offset: any }) {
    const method = "bl_1_descriptions";
    const params = {
      limit: data.limit,
      offset: data.offset,
      ent_id: _eq(data.ent_id),
      order: "class_id",
    };
    return this.get(method, params);
  }
  add_bl_1_descriptions(data: {
    parent_id: any;
    class_id: any;
    description: any;
  }) {
    const method = "bl_1_add_desc";
    const body = {
      parent_id: data.parent_id,
      class_id: data.class_id,
      ent_desc: data.description,
    };
    return this.post(method, body);
  }
  update_bl_1_descriptions(data: { id: any; description: any }) {
    const method = "bl_1_update_descriptions";
    const body = data;
    return this.post(method, body);
  }
  delete_bl_1_descriptions(data: { id: any }) {
    const method = "bl_1_delete_desc";
    const body = { desc_id: data.id };
    return this.post(method, body);
  }
  get_bl_1_warehouse_prod(data: { limit: any; offset: any; filter_name: any }) {
    const method = "bl_1_warehouse_prod";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order: "name",
      name: _ilike(data.filter_name),
    };
    return this.get(method, params);
  }
  // ===========================================================
  // dataset v2
  // ===========================================================
  get_dataset_v2_tags(data: {
    name: any;
    task_id: any;
    type: any;
    limit: any;
    offset: any;
    is_deleted: any;
    ilike: any;
  }) {
    const method = "dataset_v2_tags";
    const order = "sort_crutch_s, sort_crutch_n, name";
    const params = {
      order,
      limit: data.limit,
      offset: data.offset,
      type: _eq(data.type),
      name: data.ilike ? _ilike(data.name) : _eq(data.name),
      task_id: _eq(data.task_id),
      is_deleted: _eq(data.is_deleted ? undefined : false),
    };
    return this.get(method, params);
  }
  get_dataset_v2_examples_count(data: {
    tag_ids: any;
    mark_object_comment: any;
    task_id: any;
    or_tag_ids: any;
  }) {
    const method = "dataset_v2_examples_count";
    const body = data;
    return this.post(method, body);
  }
  get_dataset_v2_examples(data: {
    lim: any;
    offs: any;
    tag_ids: any;
    mark_object_comment: any;
    task_id: any;
    or_tag_ids: any;
  }) {
    const method = "get_dataset_v2_examples";
    const body = data;
    return this.post(method, body);
  }
  get_dataset_v2_example(data: { id: any; task_id: any }) {
    const method = "get_dataset_v2_example";
    const body = data;
    return this.post(method, body);
  }
  set_dataset_v2_example(
    task_id: any,
    example: {
      id: any;
      line: any;
      type: any;
      mark_object: {
        id: any;
        type: any;
        comment: any;
        at: Date;
        user_name: any;
      };
      at: Date | undefined;
      user_name: any;
    },
  ) {
    const method = "set_dataset_v2_example";
    const body = { example, task_id, user_name: this.store.state.user.id };
    return this.post(method, body);
  }
  del_dataset_v2_example(mark_object_id: any) {
    const method = "del_dataset_v2_example";
    const body = { mark_object_id, user_name: this.store.state.user.id };
    return this.post(method, body);
  }
  del_dataset_v2_example_with_filter(data: {
    tag_ids: any;
    mark_object_comment: any;
    task_id: any;
    or_tag_ids: any;
  }) {
    const method = "del_dataset_v2_example_with_filter";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v2_add_text(data: { line: any; state: any; tag_ids: any }) {
    const method = "dataset_v2_add_text";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v2_add_image(data: { url: any; state: any; tag_ids: any }) {
    const method = "dataset_v2_add_image";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v2_add_tag(data: { name: any; type: any; task_id: any }) {
    const method = "dataset_v2_add_tag";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v2_set_tag_is_deleted(data: {
    tag_id: any;
    task_id: any;
    is_deleted: any;
  }) {
    const method = "dataset_v2_set_tag_is_deleted";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  // ===========================================================
  // dataset v3
  // ===========================================================
  // object
  dataset_v3_object_delete(data: { id: any }) {
    const method = "dataset_v3_object_delete";
    const body = { ...data, user_name: this.store.state.user.id };
    return this.post(method, body);
  }
  // tags
  dataset_v3_tags(data: { ids: any; code: any; limit: any; offset: any }) {
    const method = "dataset_v3_tags";
    const order = "sort_crutch_s, sort_crutch_n, code";
    const params = {
      order,
      limit: data.limit,
      offset: data.offset,
      code: _ilike(data.code),
      or: _or("id", data.ids, "eq"),
    };
    return this.get(method, params);
  }
  dataset_v3_tags_add(data: { codes: any }) {
    const method = "dataset_v3_tags_add";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  // texts
  dataset_v3_get_texts(data: {
    text: any;
    and_tags: any;
    or_tags: any;
    not_tags: any;
    lim: any;
    offs: any;
    ord: any;
    is_asc: any;
  }) {
    const method = "dataset_v3_get_texts_v2";
    const body = data;
    return this.post(method, body);
  }
  dataset_v3_text_update(data: {
    object_id: any;
    line: any;
    comment: any;
    tags: any;
  }) {
    const method = "dataset_v3_text_update_v2";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  // imgs
  dataset_v3_get_images(data: {
    text: any;
    and_tags: any;
    or_tags: any;
    not_tags: any;
    lim: any;
    offs: any;
    ord: any;
    is_asc: any;
  }) {
    const method = "dataset_v3_get_images";
    const body = data;
    return this.post(method, body);
  }
  dataset_v3_image_update(data: { object_id: any; comment: any; tags: any }) {
    const method = "dataset_v3_image_update";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v3_image_polygon_save(data: {
    image_id: any;
    object_id: any;
    points_sets: any;
    comment: any;
    tags: any;
  }) {
    const method = "dataset_v3_image_polygon_save";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  // templates
  dataset_v3_template_names(data: {
    object_id: any;
    name: any;
    limit: any;
    offset: any;
  }) {
    const method = "dataset_v3_template_names";
    const order = "name";
    const params = {
      order,
      limit: data.limit,
      offset: data.offset,
      object_id: _eq(data.object_id),
      or: data.name ? _or("name", [data.name, null], "ilike", "*") : undefined,
    };
    return this.get(method, params);
  }
  dataset_v3_get_template_children(parent_id: any, object_id: undefined) {
    const method = "dataset_v3_get_template_children";
    const body = { parent_id, object_id };
    return this.post(method, body);
  }
  dataset_v3_template_example(node_id: any) {
    const method = "dataset_v3_template_example";
    const body = { node_id };
    return this.post(method, body);
  }
  dataset_v3_template_add(data: {
    parent_id: any;
    name: any;
    type: any;
    value: any;
    template_id: any;
    is_template: any;
    comment: any;
    tags: any;
  }) {
    const method = "dataset_v3_template_add";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v3_template_update(data: {
    object_id: any;
    parent_id: any;
    name: any;
    type: any;
    ord: any;
    value: any;
    template_id: any;
    comment: any;
    tags: any;
  }) {
    const method = "dataset_v3_template_update";
    const body = {
      ...data,
      user_name: this.store.state.user.id,
    };
    return this.post(method, body);
  }
  dataset_v3_template_update_ord(need_object_id: any, pre_object_id: any) {
    const method = "dataset_v3_template_update_ord";
    const body = { need_object_id, pre_object_id };
    return this.post(method, body);
  }
  // ===========================================================
  // datamaster
  // ===========================================================
  get_classes(data: { limit: any; offset: any; filter: string; is_used: any }) {
    const method = "t_answers";
    const order = "internal_id";
    data.filter = data.filter || "";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order,
      answer: _ilike(data.filter),
      is_used: _eq(data.is_used),
    };
    return this.get(method, params);
  }
  get_classes_by_intenral_id(data: {
    limit: any;
    offset: any;
    filter: string;
    is_used: any;
  }) {
    const method = "t_answers";
    const order = "internal_id";
    data.filter = data.filter || "";
    const params = {
      limit: data.limit,
      offset: data.offset,
      order,
      text_internal_id: _ilike(data.filter),
      is_used: _eq(data.is_used),
    };
    return this.get(method, params);
  }
  add_class(
    answer: any,
    external_id: any,
    internal_id: any,
    question_template: any,
    section1_id: any,
    section2_id: any,
    is_used: any,
    is_operation: any,
    is_class: any,
    is_changed: any,
  ) {
    const method = "public_data_answers_insert";
    const body = {
      answer,
      external_id,
      internal_id,
      question_template,
      section1_id,
      section2_id,
      is_used,
      is_operation,
      is_class,
      is_changed,
    };
    return this.post(method, body);
  }
  is_internal_id_busy(id_to_check: any) {
    const method = "public_data_answers_internal_id_is_busy";
    const body = { id_to_check };
    return this.post(method, body);
  }
  delete_class(id_to_del: any) {
    const method = "public_data_answers_delete";
    const body = { id_to_del };
    return this.post(method, body);
  }
  update_class(
    upd_id: any,
    answer: any,
    external_id: any,
    internal_id: any,
    question_template: any,
    section1_id: any,
    section2_id: any,
    is_used: any,
    is_operation: any,
    is_class: any,
    is_changed: any,
  ) {
    const method = "public_data_answers_update";
    const body = {
      upd_id,
      answer,
      external_id,
      internal_id,
      question_template,
      section1_id,
      section2_id,
      is_used,
      is_operation,
      is_class,
      is_changed,
    };
    return this.post(method, body);
  }
  // === answers_sections ===
  get_answers_sections1() {
    const method = "answers_sections1";
    const order = "id.desc";
    const params = { order };
    return this.get(method, params);
  }
  get_answers_sections2() {
    const method = "answers_sections2";
    const order = "id.desc";
    const params = { order };
    return this.get(method, params);
  }
  add_answers_sections1(label: any) {
    const method = "public_data_insert_answers_sections1";
    const body = {
      label,
    };
    return this.post(method, body);
  }
  add_answers_sections2(label: any) {
    const method = "public_data_insert_answers_sections2";
    const body = {
      label,
    };
    return this.post(method, body);
  }
  update_answers_sections1(id: any, label: any) {
    const method = "public_data_update_answers_sections1";
    const body = {
      id,
      label,
    };
    return this.post(method, body);
  }
  update_answers_sections2(id: any, label: any) {
    const method = "public_data_update_answers_sections2";
    const body = {
      id,
      label,
    };
    return this.post(method, body);
  }
  delete_answers_sections1(id: any) {
    const method = "public_data_delete_answers_sections1";
    const body = {
      id,
    };
    return this.post(method, body);
  }
  delete_answers_sections2(id: any) {
    const method = "public_data_delete_answers_sections2";
    const body = {
      id,
    };
    return this.post(method, body);
  }
  // Tlgrm schema methods
  tlgrm_get_event_log_length(type: any) {
    const method = "tlgrm_get_event_log_length";
    const body = {
      x_type: type,
    };
    return this.post(method, body);
  }
  tlgrm_get_event_log(type: any, limit: any, skip: any) {
    const method = "tlgrm_get_event_log";
    const body = {
      x_type: type,
      x_count: limit,
      x_skip: skip,
    };
    return this.post(method, body);
  }
  tlgrm_set_event_type(guid: any, type: any) {
    const method = "tlgrm_set_event_type";
    const body = {
      x_guid: guid,
      x_type: type,
    };
    return this.post(method, body);
  }
  tlgrm_get_relations(bot = null, channel = null, enabled = null) {
    const method = "tlgrm_get_relations";
    const body = {
      bot_ref: bot,
      channel_ref: channel,
      is_enabled: enabled,
    };
    return this.post(method, body);
  }
  tlgrm_iou_relations(relations: any) {
    const method = "tlgrm_iou_relations";
    const body = {
      input: relations,
    };
    return this.post(method, body);
  }
  idom_get_accounts(body: IBotQueryParams) {
    const method = "idom_get_accounts";
    return this.post(method, body);
  }
  idom_get_accounts_count(body: IBotQueryParams) {
    const method = "idom_get_accounts_count";
    return this.post(method, body);
  }
  idom_save_accounts(accounts: any) {
    const method = "idom_save_accounts";
    const body = {
      accounts,
    };
    return this.post(method, body);
  }
  idom_get_mimicry(account_guid: any) {
    const method = "idom_get_mimicry";
    const body = {
      account_guid,
    };
    return this.post(method, body);
  }
  idom_save_mimicry(mimicry: any) {
    const method = "idom_save_mimicry";
    const body = {
      mimicry: [mimicry],
    };
    return this.post(method, body);
  }
  idom_get_channels(body: IChannelQueryParams) {
    const method = "idom_get_channels";
    return this.post(method, body);
  }
  idom_save_channels(channels: any) {
    const method = "idom_save_channels";
    const body = {
      channels,
    };
    return this.post(method, body);
  }

  idom_get_channels_count(body: IChannelQueryParams) {
    const method = "idom_get_channels_count";
    return this.post(method, body);
  }
  idom_get_subscriptions(body: {
    account_guid?: string;
    channel_guid?: string;
    enabled?: boolean;
    limit?: number;
    offset?: number;
  }) {
    const method = "idom_get_subscriptions_with_parameters";
    return this.post(method, body);
  }
  idom_save_subscriptions(subscriptions: any) {
    const method = "idom_save_subscriptions";
    const body = {
      subscriptions,
    };
    return this.post(method, body);
  }
  idom_get_platforms() {
    const method = "idom_get_platforms";
    const body = {};
    return this.post(method, body);
  }
  idom_get_autosend_options() {
    const method = "idom_get_autosend_options";
    const body = {};
    return this.post(method, body);
  }
  idom_get_roles() {
    const method = "idom_get_roles";
    const body = {};
    return this.post(method, body);
  }
  idom_get_entities(body: IEntityQueryParams) {
    const method = "idom_get_entities";
    return this.post(method, body);
  }

  idom_get_entities_count(body: IEntityQueryParams) {
    const method = "idom_get_entities_count";
    return this.post(method, body);
  }
  idom_save_entities(entity: any) {
    const method = "idom_save_entities";
    const body = {
      entities: [entity],
    };
    return this.post(method, body);
  }

  idom_get_entity_types() {
    return this.post("idom_get_entity_types");
  }
  idom_save_entity_types(entity_type_guid: string[], entity_guid: string) {
    const entity_types = entity_type_guid.map((type) => ({
      entity_type_guid: type,
      entity_guid,
    }));
    return this.post("idom_save_entity_types", {
      entity_types,
    });
  }

  idom_remove_entity_types(entity_type_guid: string[], entity_guid: string) {
    const entity_types = entity_type_guid.map((type) => ({
      entity_type_guid: type,
      entity_guid,
    }));
    return this.post("idom_remove_entity_types", {
      entity_types,
    });
  }
  idom_get_free_accounts(
    platform_guid: string,
    channel_guid: string,
    role_guid: string,
    count: number,
  ) {
    const method = "idom_get_free_accounts";
    const body = {
      platform_guid,
      channel_guid,
      role_guid,
      count,
    };
    return this.post(method, body);
  }

  // ===========================================================
  // loms
  // ===========================================================

  idom_get_loms(payload: { limit: number; offset: number; name?: string }) {
    return this.post("idom_get_loms", payload);
  }
  idom_save_lom(
    name: string,
    metadata: Record<string, string> = {},
    guid?: string,
  ) {
    return this.post("idom_save_lom", { lom: [{ name, metadata, guid }] });
  }

  idom_remove_lom(guid: string) {
    return this.post("idom_remove_lom", { lom_guid: guid });
  }

  idom_get_lom_with_parameters(guid: string) {
    return this.post("idom_get_lom_with_parameters", {
      guid,
    });
  }

  idom_save_loms_with_channels(loms_channels: IAddLomChannel[]) {
    return this.post("idom_save_loms_with_channels", {
      loms_channels,
    });
  }
  idom_save_loms_entities(loms_entities: IAddLomEntity[]) {
    return this.post("idom_save_loms_entities", {
      loms_entities,
    });
  }
  idom_remove_loms_channels(loms_channels: IAddLomChannel[]) {
    return this.post("idom_remove_loms_channels", { guids: loms_channels });
  }

  idom_remove_loms_entities(loms_entities: IAddLomEntity[]) {
    return this.post("idom_remove_loms_entities", { guids: loms_entities });
  }

  idom_get_lom_task_with_parameters(body?: ILomTaskQueryParams) {
    return this.post("idom_get_lom_task_with_parameters", body);
  }

  idom_get_lom_task_count(body?: ILomTaskQueryParams) {
    return this.post("idom_get_lom_task_count", body);
  }

  idom_lom_task_save(body: { guid: string; mediaplan: IMediaplanItem }) {
    return this.post("idom_lom_task_save", { lom_tasks: [body] });
  }

  idom_loms_tasks_approved(guid: string, status: boolean) {
    return this.post("idom_loms_tasks_approved", { guid, status });
  }

  idom_get_settings() {
    return this.post("idom_get_settings");
  }
  idom_update_setting(settings: { guid: string; value: string }[]) {
    return this.post("idom_update_setting", { settings });
  }

  idom_get_mental() {
    return this.post("idom_get_mental", {});
  }
  idom_get_nation() {
    return this.post("idom_get_nation", {});
  }
  idom_get_humorism() {
    return this.post("idom_get_humorism", {});
  }
  idom_get_aggression() {
    return this.post("idom_get_aggression", {});
  }
  idom_get_brevity() {
    return this.post("idom_get_brevity", {});
  }
  idom_get_ideology() {
    return this.post("idom_get_ideology", {});
  }
}

function _filter(value: any, fs: any, s = "") {
  if (value === undefined) return;
  if (value === null) return "is.null";
  return `${fs}.${s}${value}${s}`;
}
function _eq(value: any) {
  if (value === undefined) return;
  return _filter(value, "eq");
}
function _neq(value: any) {
  return _filter(value, "neq");
}
function _ilike(value: any) {
  return _filter(value, "ilike", "*");
}
function _or(field: any, values: any, fs: any, s = "") {
  if (!values) return;
  const res = [];
  for (const value of values) {
    const f = _filter(value, fs, s);
    if (f) res.push(`${field}.${f}`);
  }
  return res.length ? `(${res})` : undefined;
}
